var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Button, Tooltip, TooltipToggle } from 'telia-front-react';
import { observer } from 'mobx-react';
import React, { Component } from 'react';
import { MandateType } from '../../config/mandate';
import RepresentationRightsMandatesModal from './RepresentationRightsMandatesModal';
import { injectStores } from '../../util/StoresUtil';
let RepresentationRightsMandateType = class RepresentationRightsMandateType extends Component {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "translateStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
    }
    render() {
        const { mandate } = this.props;
        return mandate.getVisibleMandates().length > 1 ? this.renderModal() : this.renderMandateTypeValue();
    }
    renderMandateTypeValue() {
        const { mandate } = this.props;
        return mandate.getVisibleMandates()[0].type === MandateType.LEGAL ? this.renderWithoutTooltip() : this.renderWithTooltip();
    }
    renderWithoutTooltip() {
        const { mandate } = this.props;
        const { translate } = this.translateStore;
        return React.createElement("span", null, translate(`personPowers.mandate.type.${mandate.getVisibleMandates()[0].type}`));
    }
    renderWithTooltip() {
        const { mandate } = this.props;
        const { translate } = this.translateStore;
        const firstVisibleMandateType = mandate.getVisibleMandates()[0].type;
        return (React.createElement("span", null,
            React.createElement(Tooltip, { referenceElement: React.createElement(TooltipToggle, { id: `mandate-type-tooltip-${mandate.redisId}` }, translate(`personPowers.mandate.type.${firstVisibleMandateType}`)) }, translate(`personPowers.mandate.type.${firstVisibleMandateType}-tooltip`))));
    }
    renderModal() {
        const { mandate, type } = this.props;
        const { translate } = this.translateStore;
        return (React.createElement(RepresentationRightsMandatesModal, { mandate, type },
            React.createElement(Button, { text: translate('personPowers.showMandates'), link: true, isUnderlined: false })));
    }
};
RepresentationRightsMandateType = __decorate([
    injectStores,
    observer
], RepresentationRightsMandateType);
export default RepresentationRightsMandateType;
